export default __webpack_public_path__ + "static/media/H4007.1.4b461b38.mp3";